import type { AITTheme } from '@this/shared/ui/theme';

export function getStyles(theme: AITTheme) {
  const textPrimary = theme.tokens.colors.text.primary;
  const textSecondary = theme.tokens.colors.text.description;

  const tableHeaderCell = {
    fontSize: '12px',
    fontWeight: 700,
    background: 'transparent',
    borderBottom: '1px solid #D3D7DB',
    lineHeight: 1,
    padding: '0 4px 12px'
  } as const;

  const tableBodyCell = {
    padding: '12px 4px',
    verticalAlign: 'middle' as const,
    fontSize: '14px',
    borderBottom: '1px solid #D3D7DB',
    lineHeight: 1.5
  } as const;

  return {
    pageLayout: {
      width: '100%',
      minWidth: 0,
      boxSizing: 'border-box' as const
    } as const,
    pageHeader: {
      display: 'flex' as const,
      alignItems: 'center' as const,
      justifyContent: 'space-between' as const,
      gap: '16px',
      padding: '20px',
      flexWrap: 'wrap' as const
    } as const,
    pageTitle: {
      margin: 0,
      fontSize: '18px',
      fontWeight: 700,
      color: textPrimary
    } as const,
    contentIn: {
      width: '100%',
      minWidth: 0,
      padding: '0 20px 20px',
      boxSizing: 'border-box' as const
    } as const,
    addButton: {
      width: '200px'
    } as const,
    tableWrapper: {
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      overflow: 'hidden' as const
    } as const,
    tableHeaderCell,
    tableHeaderCellActions: {
      ...tableHeaderCell,
      textAlign: 'right' as const
    } as const,
    tableBodyCell,
    tableBodyCellText: {
      ...tableBodyCell,
      whiteSpace: 'pre-wrap' as const,
      wordBreak: 'break-word' as const
    } as const,
    tableBodyCellUrl: {
      ...tableBodyCell,
      wordBreak: 'break-all' as const
    } as const,
    tableBodyCellActions: {
      ...tableBodyCell,
      textAlign: 'right' as const
    } as const,
    rowActions: {
      display: 'inline-flex' as const,
      alignItems: 'center' as const,
      justifyContent: 'flex-end' as const,
      gap: '12px',
      flexWrap: 'wrap' as const
    } as const,
    tableActionButton: {
      height: '32px',
      minHeight: '32px',
      minWidth: '64px',
      padding: '3px 10px',
      boxSizing: 'border-box' as const,
      lineHeight: 1.5,
      fontSize: '0.7544642857142857rem',
      boxShadow: 'none'
    } as const,
    emptyMessage: {
      padding: '24px 20px',
      fontSize: '14px',
      color: textSecondary,
      textAlign: 'center' as const
    } as const
  };
}
